import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { rem } from 'design-system';
import NotificationBanner from 'design-system/NotificationBanner';
import Text from 'design-system/Text';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import { setDidClosePotsCTAfromAnalytics, setDidClosePotsCTAfromBudgeting, setDidClosePotsCTAfromPots, setDidClosePotsCTAfromTransactions, } from 'actions/deviceSettings';
import { assertUnreachable } from 'utils';
import useHandleOpenInterestPot from '../hooks/useHandleOpenInterestPot';
import { selectMaximumInterest, selectPotsStatuses, selectShouldShowOpenPotsNotificationBanner, } from '../reducers/selectors';
const OpenPotsAccountNotificationBanner = ({ from, noMarginTop, noMarginBottom, buttonText = 'Open pot', }) => {
    const dispatch = useAppDispatch();
    const { navigateToTab } = useTabNavigation();
    const { status } = useAppSelector(selectPotsStatuses);
    const maximumInterest = useAppSelector(selectMaximumInterest);
    const didCloseInPast = useAppSelector((state) => selectShouldShowOpenPotsNotificationBanner(state, from));
    const navigateToOpenInterestPot = useHandleOpenInterestPot();
    const handleCancel = useCallback(() => {
        switch (from) {
            case 'Analytics':
                dispatch(setDidClosePotsCTAfromAnalytics());
                break;
            case 'Budgeting':
                dispatch(setDidClosePotsCTAfromBudgeting());
                break;
            case 'Transactions':
                dispatch(setDidClosePotsCTAfromTransactions());
                break;
            case 'Pots':
                dispatch(setDidClosePotsCTAfromPots());
                break;
            default:
                assertUnreachable(from);
                break;
        }
    }, [from]);
    const handleOpenPot = useCallback(() => {
        if (from === 'Pots') {
            navigateToOpenInterestPot();
        }
        else {
            navigateToTab('Save', { tab: 'pots' });
        }
    }, [from, navigateToOpenInterestPot, navigateToTab]);
    if (from === 'Pots' && (!maximumInterest || !!didCloseInPast)) {
        return null;
    }
    if (from !== 'Pots' && (!maximumInterest || status === 'ACTIVE' || didCloseInPast)) {
        return null;
    }
    return (<NotificationBanner lightButton noMarginTop={noMarginTop} noMarginBottom={noMarginBottom} onCancel={handleCancel} title="Grow your savings" cancelButtonTitle="Dismiss" positiveButtonTitle={buttonText} onPositiveBtnPress={handleOpenPot} description={<Text TextThin-14 Secondary>
          Earn up to{' '}
          <Text NumbersThin-14 Secondary>
            {maximumInterest}
          </Text>
          % AER when opening an Interest Pot.{' '}
          <Text Text-14 Secondary>
            FSCS applies.
          </Text>
        </Text>} containerStyles={from === 'Pots' && styles.container}/>);
};
const styles = StyleSheet.create({
    container: {
        paddingTop: rem(8),
    },
});
export default OpenPotsAccountNotificationBanner;
